//v1
// if(typeof BSS_B2B != undefined) {
//   window.addEventListener("cart_changed", () => {
//     setTimeout(() => {
//       let storeData = JSON.parse($("#bss-b2b-store-data").html());
//       BSS_B2B.makeChangesAfterClickAjaxCart(500)
//       BSS_B2B.cart.fixer(storeData, null, false);
//       BSS_B2B.handleCartCheckoutBtn(storeData);
//     }, 500);
//   });

//   setTimeout(() =>{
//     const targetMiniCart = document.querySelector(".cart-drawer");
//     if (targetMiniCart) {
//       const mutationObserver = new MutationObserver((recordList, observe) => {
//           BSS_B2B.makeChangesAfterClickAjaxCart(500)
//            BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
//           setTimeout(() =>{
//             BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
//           }, 1000)
//       });
//       mutationObserver.observe(targetMiniCart, { attributes: true });
//     }
//   }, 500)

//   //fix quick add
//   setTimeout(() =>{
//     const quickAdd = document.querySelector("cart-notification-drawer");
//     if (quickAdd) {
//       const mutationObserver = new MutationObserver((recordList, observe) => {
//           BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, false);
//       });
//       mutationObserver.observe(quickAdd, { attributes: true });
//     }
//   }, 500)

//   //fix spam checkout 
//   setTimeout(() =>{
//     function handleButtonClick(e) {
//       e.preventDefault();
//       const $button = $(this);
//       let oldText = $(this).text();
//       $button.css({'pointer-events': 'none', 'opacity': '0.6'});
//       $button.text("Loading ...");
//       setTimeout(() =>{
//         $button.css({'pointer-events': 'unset', 'opacity': '1'})
//           $button.text(oldText);
//       }, 2000);
//     }
   
//    $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
//   }, 500)

// BSS_B2B.customTriggerCheckoutBtn = function(checkoutBtn){
//     window.location.href = "/checkout";
//   }
  
// }


//v3
setTimeout(() => {
const predictive_search = document.querySelector('search-drawer');
  if(predictive_search){
    const observer = new MutationObserver(async (MutationList) => {
      for(let item of MutationList){
        if(item.target.className.includes('bss-b2b-search-bar')){
          const res = await BSS_B2B.storage.productStorage.load();
          document.dispatchEvent(
                        new CustomEvent(`bss_b2b:SearchBarLoaded`, { bubbles: true, detail: res })
                    );
        }
      }
    })
    observer.observe(predictive_search, {childList: true, subtree: true, attributes: true})
  }
}, 300)